import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/company/business_open.png';
import _imports_1 from '@/assets/company/business_opened.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4103495a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "business-container"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "业务管理页面", -1);
});

var _hoisted_3 = {
  key: 0,
  class: "reminder"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0
  }, null, -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "center"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "label1"
  }, "开启多个业务模块"), /*#__PURE__*/_createElementVNode("span", {
    class: "sub-label"
  }, [/*#__PURE__*/_createElementVNode("p", null, "业务字段可用来标识企业内不同业务条线，用作成本核算等。"), /*#__PURE__*/_createElementVNode("p", null, " 当前企业默认仅支持维护1个初始化业务，可由企业管理员根据自身企业业务复杂度来选择是否开启多个业务板块。 ")])], -1);
});

var _hoisted_6 = {
  key: 1,
  class: "reminder"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1
  }, null, -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "center"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "label1"
  }, "已开启多个业务模块"), /*#__PURE__*/_createElementVNode("p", {
    class: "label2"
  }, " 当前企业已开启多个业务板块，可由企业管理员新建业务、分配/更改业务管理员，同时新建空间时须关联业务。 ")], -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconplus-line"
  }, null, -1);
});

var _hoisted_10 = /*#__PURE__*/_createTextVNode("新增业务 ");

var _hoisted_11 = [_hoisted_9, _hoisted_10];
var _hoisted_12 = {
  class: "table"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = ["onClick"];
var _hoisted_15 = ["onClick"];
var _hoisted_16 = {
  class: "pager"
};
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, reactive, ref } from 'vue';
import CompanyService from '@/api/company';
import Pagination from '@/components/pagination.vue';
import editBusinessDialog from '../Components/editBusinessDialog.vue';
import associateSpaceDrawer from '../Components/associateSpaceDrawer.vue';
import addBusinessDialog from '../Components/addBusinessDialog.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import LoadingSlot from '../Components/loading.vue';
import TableEmpty from '../Components/tableEmpty.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _window$AppConfig;

    var route = useRoute();
    var store = useStore();
    var detail = computed(function () {
      return store.state.company.detail;
    });
    var userDetail = computed(function () {
      return store.state.user.userDetail;
    });
    var corporationId = computed(function () {
      var _route$params$company;

      return ((_route$params$company = route.params.company_id) === null || _route$params$company === void 0 ? void 0 : _route$params$company.toString()) || '';
    });

    var _ref = ((_window$AppConfig = window.AppConfig) === null || _window$AppConfig === void 0 ? void 0 : _window$AppConfig.corporation) || {},
        _ref$showSRETree = _ref.showSRETree,
        showSRETree = _ref$showSRETree === void 0 ? false : _ref$showSRETree;

    var isAdmin = computed(function () {
      return store.state.company.isAdmin;
    });
    var detailData = ref({});
    var tableLoading = ref(false); // 编辑业务弹窗

    var editDialogVisible = ref(false); // 新增业务弹窗

    var addDialogVisible = ref(false);
    var drawerVisible = ref(false);
    var pagination = reactive({
      total: 0
    });
    var tableData = ref([]);
    var pager = reactive({
      current: 1,
      pageSize: 10
    }); // 对于内网，新建业务的人员暂不做限制；对于外网(tob版本)仅企业管理员可见

    var hasAddBusiAuth = computed(function () {
      // 内网版本，所有用户可以新增
      if (!window.AppConfig.outerWebFlag) {
        return true;
      } // 对于外网(tob版本)仅企业管理员可新增


      return isAdmin.value;
    }); // 内网默认已经开启多个业务；外网(tob版本)仅企业管理员才有开启业务的权限

    var hasOpenBusiAuth = computed(function () {
      return isAdmin.value;
    }); // 对于内网，所有用户可编辑；外网(tob版本)仅企业管理员/对应的业务管理员才能编辑

    var hasEditBusiAuth = computed(function () {
      // 内网版本，所有用户可以新增
      if (!window.AppConfig.outerWebFlag) {
        return true;
      } // 对于外网(tob版本)仅企业管理员可新增


      return isAdmin.value;
    });

    var checkIsBusiAdmin = function checkIsBusiAdmin(list) {
      var _list$map, _userDetail$value;

      return (_list$map = list.map(function (item) {
        return item.userId;
      })) === null || _list$map === void 0 ? void 0 : _list$map.includes((_userDetail$value = userDetail.value) === null || _userDetail$value === void 0 ? void 0 : _userDetail$value.id);
    };

    var checkHasEditAuth = function checkHasEditAuth(row) {
      // 内网版本，所有用户可编辑
      if (!window.AppConfig.outerWebFlag) {
        return true;
      } // 外网版本，仅企业管理员&对应的业务管理员可编辑


      return isAdmin.value || checkIsBusiAdmin((row === null || row === void 0 ? void 0 : row.busiMemberVOList) || []);
    };

    var handleDrawerClose = function handleDrawerClose() {
      drawerVisible.value = false;
    };

    var handleDialogClose = function handleDialogClose() {
      editDialogVisible.value = false;
    };

    var handleAddDialogClose = function handleAddDialogClose() {
      addDialogVisible.value = false;
    };

    var searchList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tableLoading.value = true;
                _context.next = 3;
                return CompanyService.queryBusinessList({
                  corporationId: corporationId.value,
                  pageNo: pager.current,
                  pageSize: pager.pageSize
                });

              case 3:
                data = _context.sent;
                tableLoading.value = false;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  tableData.value = data.data.result.itemList;
                  pagination.total = data.data.result.totalCount;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchList() {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleUpdateList = function handleUpdateList() {
      searchList();
    };

    var onChangePage = function onChangePage(detail) {
      console.log('onChangePage', detail);

      if (detail.pageSize) {
        pager.pageSize = detail.pageSize;
      }

      if (detail.pageNo) {
        pager.current = detail.pageNo;
      }

      searchList();
    };

    var handleEdit = function handleEdit(index, row) {
      editDialogVisible.value = true;
      detailData.value = row;
    };

    var handleAssociate = function handleAssociate(index, row) {
      detailData.value = row;
      drawerVisible.value = true;
    };

    var goSREDetail = function goSREDetail(idPath) {
      var idList = idPath.split('/').filter(function (item) {
        return !!item;
      }) || [];
      var id = idList.pop();

      if (id) {
        var href = "https://sre.woa.com/#/cost/nodeManage?id=".concat(id, "&type=biz");
        window.open(href, '_blank');
      }
    }; // 开启业务模块


    var enableBusiHandler = function enableBusiHandler() {
      if (!hasOpenBusiAuth.value) {
        return;
      }

      ElMessageBox.confirm('开启后，需在创建/管理空间时配置对应的业务，可能会增加管理复杂度，同时不可关闭。请确认是否开启？', '开启多个业务模块', {
        confirmButtonText: '确认开启',
        cancelButtonText: '取消'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data2;

        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return CompanyService.enabledBusi({
                  corporationId: corporationId.value
                });

              case 2:
                data = _context2.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  store.dispatch('company/getCompanyInfo', {
                    corporation_id: corporationId.value
                  });
                  ElMessage.success('您已成功开启多个业务模块');
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }; // 新增业务模块


    var addBusiHandler = function addBusiHandler() {
      if (!hasAddBusiAuth.value) {
        return;
      }

      addDialogVisible.value = true;
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              searchList();

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_table = _resolveComponent("el-table");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _unref(detail).enabled_busi === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", {
        class: _normalizeClass(['btn', {
          'btn-disabled': !_unref(hasOpenBusiAuth)
        }]),
        onClick: enableBusiHandler
      }, " 立即开启 ", 2)])) : _unref(detail).enabled_busi === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("div", {
        class: _normalizeClass(['btn create-btn', {
          'btn-disabled': !_unref(hasAddBusiAuth)
        }]),
        onClick: addBusiHandler
      }, _hoisted_11, 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(LoadingSlot, {
        loading: tableLoading.value
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table, {
            data: tableData.value,
            style: {
              "width": "100%"
            },
            "header-row-class-name": "table-header"
          }, {
            empty: _withCtx(function () {
              return [_createVNode(TableEmpty, {
                emptyText: "暂无数据"
              })];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                label: "业务ID"
              }, {
                default: _withCtx(function (scope) {
                  return [_createTextVNode(_toDisplayString(scope.row.busiId), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "业务英文标识"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("div", null, _toDisplayString(scope.row.busiCode), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "业务名称"
              }, {
                default: _withCtx(function (scope) {
                  return [_createTextVNode(_toDisplayString(scope.row.busiName), 1)];
                }),
                _: 1
              }), _unref(showSRETree) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "关联SRE业务树"
              }, {
                default: _withCtx(function (scope) {
                  return [_createTextVNode(_toDisplayString(scope.row.sreBusiNamePath), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true), _unref(showSRETree) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                label: "关联SRE业务树ID"
              }, {
                default: _withCtx(function (scope) {
                  return [_createTextVNode(_toDisplayString(scope.row.sreBusiIdPath) + " ", 1), scope.row.sreBusiIdPath ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "sre-detail",
                    onClick: function onClick($event) {
                      return goSREDetail(scope.row.sreBusiIdPath);
                    }
                  }, "查看详情", 8, _hoisted_13)) : _createCommentVNode("", true)];
                }),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
                label: "业务管理员"
              }, {
                default: _withCtx(function (scope) {
                  var _scope$row$busiMember, _scope$row$busiMember2;

                  return [_createElementVNode("div", null, _toDisplayString((_scope$row$busiMember = scope.row.busiMemberVOList) === null || _scope$row$busiMember === void 0 ? void 0 : (_scope$row$busiMember2 = _scope$row$busiMember.map(function (item) {
                    return item.userName;
                  })) === null || _scope$row$busiMember2 === void 0 ? void 0 : _scope$row$busiMember2.join(';')), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作"
              }, {
                default: _withCtx(function (scope) {
                  return [checkHasEditAuth(scope.row) ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: function onClick($event) {
                      return handleEdit(scope.$index, scope.row);
                    },
                    class: "operate edit"
                  }, "编辑", 8, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("span", {
                    onClick: function onClick($event) {
                      return handleAssociate(scope.$index, scope.row);
                    },
                    class: "operate relate"
                  }, "查看关联空间", 8, _hoisted_15)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data"])];
        }),
        _: 1
      }, 8, ["loading"]), _createElementVNode("div", _hoisted_16, [_createVNode(Pagination, {
        options: _unref(pagination),
        params: _unref(pager),
        onOnChange: onChangePage
      }, null, 8, ["options", "params"])])]), _createVNode(editBusinessDialog, {
        detailData: detailData.value,
        visible: editDialogVisible.value,
        showSRETree: _unref(showSRETree),
        corporationId: _unref(corporationId),
        onCloseDialog: handleDialogClose,
        onUpdateList: handleUpdateList
      }, null, 8, ["detailData", "visible", "showSRETree", "corporationId"]), addDialogVisible.value ? (_openBlock(), _createBlock(addBusinessDialog, {
        key: 2,
        detailData: detailData.value,
        visible: addDialogVisible.value,
        corporationId: _unref(corporationId),
        showSRETree: _unref(showSRETree),
        onCloseDialog: handleAddDialogClose,
        onUpdateList: handleUpdateList
      }, null, 8, ["detailData", "visible", "corporationId", "showSRETree"])) : _createCommentVNode("", true), _createVNode(associateSpaceDrawer, {
        detailData: detailData.value,
        corporationId: _unref(corporationId),
        visible: drawerVisible.value,
        onClose: handleDrawerClose
      }, null, 8, ["detailData", "corporationId", "visible"])]);
    };
  }
});